import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';

const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
const aliases = {terraclassic: 'terra', lunc: 'terra', luna: 'terra2', terra: 'terra2', cosmos: 'cosmoshub'};

// Preserve old bookmarks while using the shared live dashboard.
export default function ChainDetails() {
  const { chainName } = useParams();
  const [destination, setDestination] = useState(null);
  const name = normalize(chainName);
  useEffect(() => {
    let active = true;
    setDestination(null);
    if (aliases[name]) { setDestination(`/stats/${aliases[name]}`); return () => { active = false; }; }
    fetch('/api/cosmos/chains').then((response) => {
      if (!response.ok) throw new Error('Unavailable');
      return response.json();
    }).then((data) => {
      const chain = (data.chains || []).find((entry) => [entry.key, entry.prettyName, entry.chainId, entry.symbol].some((value) => normalize(value) === name));
      if (active) setDestination(chain ? `/stats/${encodeURIComponent(chain.key)}` : '/stats');
    }).catch(() => { if (active) setDestination('/stats'); });
    return () => { active = false; };
  }, [name]);
  return destination ? <Navigate to={destination} replace /> : <section className="site-not-found" role="status">Opening live chain dashboard…</section>;
}